class ColHeader {
  constructor (treeManager, sourceColHeader, depth, parent) {
    // Extended properties
    // Can we use a spread operator for this?
    Object.keys(sourceColHeader).forEach(key => { this[key] = sourceColHeader[key] })

    // Base properties
    this.id = sourceColHeader.id
    this.name = sourceColHeader.sameDepthAsParent ? '' : sourceColHeader.name

    // Table construction properties
    this.depth = sourceColHeader.sameDepthAsParent ? parent.depth : depth
    this.childCount = sourceColHeader.children.length
    this.children = []
    this.resolvedChildren = []
    this.colSpan = 1
    this.rowSpan = 0
    this.parentId = parent ? parent.id : null
    this.parent = parent
    this.xCoord = null
    this.yCoord = null

    this.treeManager = treeManager
  }

  tryResolve () {
    this.rowSpan++

    if (this.canResolve() && this.parent) this.parent.resolveChild(this)
  }

  canResolve () {
    return this.resolvedChildren.length === this.childCount
  }

  resolveChild (child) {
    if (!this.resolvedChildren.find(item => item === child.id)) this.resolvedChildren.push(child.id)

    if (this.canResolve()) this.treeManager.activateNode(this)
  }
}

class ColHeaderTreeManager {
  constructor (sourceHeaders) {
    this.rootId = null
    this.bottomNodes = []
    this.activeNodes = []
    this.maxDepth = 0

    this.getReverseTreeInfo(sourceHeaders)
  }

  // DO TODO: Temporary solution to support both flat and tree structures.
  // should be removed after migrating exclusively to flat structure
  getReverseTreeInfo (headers) {
    headers.hasOwnProperty('id') ? this.processTreeSourceData(headers) : this.processFlatSourceData(headers)
  }

  processFlatSourceData (headers) {
    Object.keys(headers).forEach(key => {
      let header = headers[key]

      if (header.parentId !== 0 && !header.parentId) this.rootId = header.id

      if (header.children) {
        for (let i = 0; i < header.children.length; i++) {
          header.children.sort((leftItem, rightItem) => headers[leftItem].order - headers[rightItem].order)
        }
      }
    })

    const reverseNodes = (node, depth, parent = null) => {
      const colObject = new ColHeader(this, node, depth, parent)

      for (let i = 0; i < node.children.length; i++) {
        const child = headers[node.children[i]]

        colObject.children.push(reverseNodes(child, depth + 1, colObject))
      }

      if (!colObject.childCount) this.bottomNodes.push(colObject)
      if (depth > this.maxDepth) this.maxDepth = depth

      return colObject
    }

    // Reverses the tree structure to be easier to expand into table data
    reverseNodes(headers[this.rootId], 0)

    this.activeNodes = Array.from(this.bottomNodes)
  }

  processTreeSourceData (headers) {
    this.rootId = headers.id

    const sortNode = (node) => {
      for (let i = 0; i < node.children.length; i++) {
        sortNode(node.children[i])
      }

      node.children.sort((leftItem, rightItem) => leftItem.order - rightItem.order)
    }

    sortNode(headers)

    const reverseNodes = (node, depth, parent = null) => {
      const colObject = new ColHeader(this, node, depth, parent)

      for (let i = 0; i < node.children.length; i++) {
        colObject.children.push(reverseNodes(node.children[i], depth + 1, colObject))
      }

      if (!colObject.childCount) this.bottomNodes.push(colObject)
      if (depth > this.maxDepth) this.maxDepth = depth

      return colObject
    }

    // Reverses the tree structure to be easier to expand into table data
    reverseNodes(headers, 0)

    this.activeNodes = Array.from(this.bottomNodes)
  }

  removeResolved () {
    for (var i = 0; i < this.activeNodes.length; i++) {
      if (this.activeNodes[i].parent) this.activeNodes[i].parent.resolvedChildren = []
    }
  }

  allResolved () {
    return this.activeNodes.length === 1 && this.activeNodes[0].id === this.rootId
  }

  activateNode (node) {
    const activeChildren = this.activeNodes.filter(x => x.parentId === node.id)
    node.colSpan = activeChildren.reduce((total, current) => total + current.colSpan, 0)

    this.removeChildrenByIds(activeChildren.map(item => item.id))

    this.activeNodes.push(node)
  }

  removeChildrenByIds (idArray) {
    this.activeNodes = this.activeNodes.filter(item => !idArray.includes(item.id))
  }

  getLevelFromCoord (coord) {
    const getNodeForCoord = (node, currentOffset) => {
      if (node.rowSpan > currentOffset) return node
      else if (node.parent) return getNodeForCoord(node.parent, (currentOffset - node.rowSpan))
      else return null
    }

    const currentLevel = []

    for (let i = 0; i < this.bottomNodes.length; i++) {
      const node = getNodeForCoord(this.bottomNodes[i], coord)

      if (!node) return null

      if (!currentLevel.find(x => x.id === node.id)) currentLevel.push(node)
    }

    return currentLevel
  }
}

export { ColHeader, ColHeaderTreeManager }



// WEBPACK FOOTER //
// ./src/components/report-tables/legacy/Classes/ColHeaderClasses.js